import { Store } from '@sama/app-state';
import { combineLatest, Observable } from 'rxjs';

// Relpace with s-rxjs-utils after
// https://github.com/simontonsoftware/s-rxjs-utils/issues/9
export function observeKeys<T, K1 extends keyof T>(
  store: Store<T>,
  k1: K1,
): Observable<[T[K1]]>;
export function observeKeys<T, K1 extends keyof T, K2 extends keyof T>(
  store: Store<T>,
  k1: K1,
  k2: K2,
): Observable<[T[K1], T[K2]]>;
export function observeKeys<
  T,
  K1 extends keyof T,
  K2 extends keyof T,
  K3 extends keyof T,
>(store: Store<T>, k1: K1, k2: K2, k3: K3): Observable<[T[K1], T[K2], T[K3]]>;
export function observeKeys<
  T,
  K1 extends keyof T,
  K2 extends keyof T,
  K3 extends keyof T,
  K4 extends keyof T,
>(
  store: Store<T>,
  k1: K1,
  k2: K2,
  k3: K3,
  k4: K4,
): Observable<[T[K1], T[K2], T[K3], T[K4]]>;
export function observeKeys<T>(store: Store<T>, ...keys: Array<keyof T>) {
  return combineLatest(keys.map((key) => store(key).$));
}

export function toggleState(store: Store<boolean>) {
  store.setUsing((value) => !value);
}
